'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propsComparer = require('../../utils/propsComparer');

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _AuctioneerAddress = require('./AuctioneerAddress.scss');

var _AuctioneerAddress2 = _interopRequireDefault(_AuctioneerAddress);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AuctioneerAddress = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(AuctioneerAddress, _Component);

    function AuctioneerAddress() {
        (0, _classCallCheck3.default)(this, AuctioneerAddress);
        return (0, _possibleConstructorReturn3.default)(this, (AuctioneerAddress.__proto__ || (0, _getPrototypeOf2.default)(AuctioneerAddress)).apply(this, arguments));
    }

    (0, _createClass3.default)(AuctioneerAddress, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props.seller, nextProps.seller, ['address', 'address2', 'city', 'stateCode', 'zip', 'country']) || (0, _propsComparer2.default)(this.props, nextProps, ['className']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                className = _props.className,
                seller = _props.seller;
            var address = seller.address,
                address2 = seller.address2,
                city = seller.city,
                country = seller.country,
                stateCode = seller.stateCode,
                zip = seller.zip;


            var cityWithCommaAndSpace = city + ', ';
            var stateCodeWithSpace = stateCode + ' ';

            var addressComponents = [(0, _jsx3.default)('div', {
                className: _AuctioneerAddress2.default.one
            }, 0, address)];
            if (address2) {
                addressComponents.push((0, _jsx3.default)('div', {
                    className: _AuctioneerAddress2.default.two
                }, 1, address2));
            }
            addressComponents.push((0, _jsx3.default)('div', {
                className: _AuctioneerAddress2.default.area
            }, 2, city ? cityWithCommaAndSpace : '', stateCode ? stateCodeWithSpace : '', zip));
            addressComponents.push((0, _jsx3.default)('div', {
                className: _AuctioneerAddress2.default.country
            }, 3, country));

            var classes = (0, _classnames2.default)(_AuctioneerAddress2.default.address, className);

            return (0, _jsx3.default)('div', {
                className: classes
            }, void 0, addressComponents);
        }
    }]);
    return AuctioneerAddress;
}(_react.Component), _class.defaultProps = {
    className: ''
}, _temp);
exports.default = AuctioneerAddress;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AuctioneerInfo/AuctioneerAddress.js
// module id = PbmM
// module chunks = 57